export default [
    {
        path: "course_list",
        name:  "COURSE_LIST",
        meta: {
            title: "课程列表",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/course/course.vue"),
    },
];
